import { useState, useEffect } from 'react';
import { FinanceService } from '../../../../core/services/FinanceService';

interface Props {
    idType?: number;
    idSelector: number;
    onChange: any;
    _disabled?: any;
    label?: string;
}
export const SelectBudgetType = ({ idType, idSelector, onChange, _disabled, label }: Props) => {

    const service = new FinanceService();
    const [lista, setLista] = useState([]);
    const [id, setID] = useState(0);



    useEffect(() => {
        setID(idSelector);
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [idType])


    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(parseInt(e));

    }

    const getLista = () => {

        service.getBudgetTypeCatalogByType(idType ?? 26).subscribe(
            (resp: any) => {

                if (resp.DataBeanProperties.ObjectValue) {
                    const response = resp.DataBeanProperties.ObjectValue;
                    setLista(response);
                    const exists = response.some((item: any) => item.DataBeanProperties.IDBudgetType === idSelector);
                    if ((!idSelector || !exists) && Array.isArray(response) && response.length > 0) {
                        const firstId = response[0].DataBeanProperties.IDBudgetType;
                        setID(firstId);
                        onChange(firstId);
                    } else if (idSelector) {
                        setID(idSelector);
                    }
                }
            }
        );
    }


    return (
        <>
            <label>{label ?? "Tipo de Presupuesto"}</label>
            <select disabled={_disabled} className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={0}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDBudgetType} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}